import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-7e6334ee"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "text-fa"
};
const _hoisted_2 = {
  class: "text-title"
};
const _hoisted_3 = {
  class: "title-tips"
};
const _hoisted_4 = {
  class: "text-cont-fa"
};
const _hoisted_5 = {
  key: 0,
  class: "file-list"
};
const _hoisted_6 = {
  class: "file-dis"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "filename"
};
const _hoisted_9 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LaborDetailTitleValue = _resolveComponent("LaborDetailTitleValue");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString($props.moudleName), 1)]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_LaborDetailTitleValue, {
    title: "附件材料说明",
    "show-title": false,
    value: '为培养具有全球视野，具备水生动物基础医学、预防医学和临床医学等方面的专业知识和技能，能够在水生动物疫病防控和水产养殖等相关领域与部门从事生产管理、教学科研等工作，服务于国家或区域水产动物健康安全的复合型专业人才。专业制作该课程《水产动物传染病学》，宏观介绍水产动物传染病的分类与分布、发生和流行规律、水生动物传染病的综合防制体系和水生动物传染病的救治体系。'
  }), $props.fileList && Array.isArray($props.fileList) && $props.fileList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.fileList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "file-li",
      key: index
    }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
      src: require('../laboratory/labor-file-icon-image.png'),
      class: "logo"
    }, null, 8, _hoisted_7), _createElementVNode("div", _hoisted_8, _toDisplayString(item.file_name || "-"), 1)]), _createElementVNode("div", {
      class: "file-option",
      onClick: $event => $options.hrefdetail(item.file_url || '')
    }, " 详情 ", 8, _hoisted_9)]);
  }), 128))])) : _createCommentVNode("", true)])]);
}